<div class="announcements" [ngClass]="{'hidde' : hidden === true}">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="announcements__content">
          <div class="announcements__content__text">
            <p>{{announcements.text }} <a [href]="announcements.link">{{announcements.link_text}}</a></p>
          </div>
          <div class="announcements__content__close">
            <a href="#" (click)="hiddenAnnouncement()">
              X
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
